import React from "react";
import { StateManagerContext } from "./StateManagerContext";
import { DynamicForm, DynamicFormProps } from "./DynamicForm";
import { DynamicFormElement } from "../Shared/DynamicFormElement";
import { SignUpData } from "../Shared/UserData";



export type SignUpFormProps = {
    height: number;
    width: number;
    background: string;
    fontSize: number;
    complete(): void;

}

const signUpFormJSON: DynamicFormElement[] = [
    {
        elementType : 'text',
        name : 'pageTitle',
        label : "Let's create an identity for you on Fanbox so you can engage with other fans.",
        defaultValue : '',
        options : []
    },
    {
        elementType: "textbox",
        name: "nickname",
        label: "Nickname",
        defaultValue: "",
        options: [],
        mandatory: true
    },
    {
        elementType: "textbox",
        name: "email",
        label: "Email",
        defaultValue: "",
        options: [],
        mandatory: true
    },
    {
        elementType: "text",
        name: "acceptText",
        label: "Please read our [Privacy Policy](http://fanbox.love/privacy-policy) and [Terms of Use](http://fanbox.love/terms-of-use)",
        defaultValue: "",
        options: []
    },
    {
        elementType: "check",
        name: "terms",
        label: "I confirm I have read the privacy policty and terms of service.",
        defaultValue: "",
        options: [],
        mandatory: true
    }
]



export const SignUpForm = ({ height, width, background, complete, fontSize }: SignUpFormProps): JSX.Element => {



    const stateManager = React.useContext(StateManagerContext);
    const cognito = stateManager.user().cognito;
    

        signUpFormJSON[1].defaultValue = cognito !== undefined ? cognito.nickname : '';
        signUpFormJSON[2].defaultValue = cognito !== undefined ? cognito.email : '';

        const submit = (data: { [key: string]: string }) => {
            stateManager.user().userInformation.nickname = data['nickname'];
            stateManager.user().userInformation.email = data['email'];
            stateManager.user().userInformation.signUpComplete = data['terms'] === 'true';
            const worker = async () => {
                const uri = '/api/user/signup';
                const signup: SignUpData = {
                    email: data['email'],
                    nickname: data['nickname'],
                    termsAccepted: data['terms'] === 'true'
                }
                const dataPackage = {
                    fanboxId: stateManager.user().fanbox.id,
                    accessToken: stateManager.user().fanbox.accessToken ?? '',
                    signup: signup
                }
                const response = await fetch(uri, {
                    method: "POST",
                    headers: { "content-type": "application/json" },
                    body: JSON.stringify(dataPackage)
                });
            }
            worker();
            complete();

        }

        const cancel = () => {
            //auth.signOut();
            //stateManager.updateCognito(undefined);
            complete();
        }
        const props: DynamicFormProps = {
            elements: signUpFormJSON,
            submissionButtonText: 'Sign up',
            submissionTextColor: 'black',
            submissionColor: 'pink',
            submissionDisableColor: 'midGray',
            cancelButtonText: 'Cancel',
            cancelTextColor: 'black',
            cancelColor: 'midGray',
            submit: submit,
            cancel: cancel,
            height: height,
            width: width,
            background: background,
            fontSize: fontSize,
            textColor: 'white',
            controlColor: '#A0A0A0',
            controlTextColor: 'black',
            linkColor: '#e6007e'

        }
        return <DynamicForm {...props} />
    
}